// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"Banner_bannerWrapper__20502","textContent":"Banner_textContent__3kSYR"};